import React from 'react';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ProductCard = ({ product, index = 0 }) => {
  const firstImage = product.images?.[0];
  const imgSrc = firstImage?.startsWith('/api') ? `${API_URL}${firstImage}` : firstImage;
  const hasDiscount = product.discount_percent && product.discount_percent > 0;
  const productUrl = `/produs/${product.custom_slug || product.id}`;

  return (
    <div data-testid={`product-card-${product.id}`}>
      <Link
        to={productUrl}
        className="product-card relative bg-[#121212] border border-white/5 overflow-hidden group block"
      >
        {/* Image */}
        <div className="aspect-square overflow-hidden relative bg-[#0a0a0a]">
          {imgSrc ? (
            <img
              src={imgSrc}
              alt={product.alt_texts?.[0] || product.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-[#333]">
              <svg className="w-16 h-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
          )}

          {/* Overlay on hover */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

          {/* Badge */}
          {product.badge && (
            <div className="absolute top-3 left-3 z-10">
              <span className={`text-xs font-bold px-3 py-1.5 uppercase tracking-wider ${
                product.badge === 'offer' ? 'bg-red-600 text-white' :
                product.badge === 'new' ? 'bg-[#D4AF37] text-black' :
                'bg-white text-black'
              }`}>
                {product.badge === 'offer' ? 'Ofertă' :
                 product.badge === 'new' ? 'Nou' :
                 product.badge === 'bestseller' ? 'Popular' : product.badge}
              </span>
            </div>
          )}

          {/* Discount tag */}
          {hasDiscount && (
            <div className="absolute top-3 right-3 z-10 bg-red-600 text-white text-xs font-bold px-2 py-1">
              -{product.discount_percent}%
            </div>
          )}

          {/* Hover button */}
          <div className="absolute bottom-4 left-4 right-4 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300">
            <span className="w-full bg-[#D4AF37] text-black font-semibold py-3 text-center text-sm flex items-center justify-center gap-2">
              Vezi Detalii
            </span>
          </div>
        </div>

        {/* Info */}
        <div className="p-4">
          {/* Code */}
          <p className="text-[#D4AF37] text-xs tracking-widest uppercase mb-1">{product.code}</p>
          
          {/* Name */}
          <h3 className="font-serif text-white text-base mb-3 line-clamp-2 group-hover:text-[#D4AF37] transition-colors">
            {product.name}
          </h3>

          {/* Price */}
          {product.price ? (
            <div className="flex items-baseline gap-2">
              {hasDiscount ? (
                <>
                  <span className="text-[#D4AF37] font-bold text-lg">
                    {product.discounted_price?.toFixed(2)} Lei
                  </span>
                  <span className="text-[#666] line-through text-sm">
                    {product.price.toFixed(2)} Lei
                  </span>
                </>
              ) : (
                <span className="text-[#D4AF37] font-bold text-lg">
                  {product.price.toFixed(2)} Lei
                </span>
              )}
            </div>
          ) : (
            <span className="text-[#D4AF37] text-sm font-medium">Solicită Ofertă</span>
          )}
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;
